import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const SLR3_4FEET_LAYER_ID = 'slr3_4FeetLayer';

const layerConfig = {
  title: 'SLR 3.4 Feet',
};

function SLR3_4FeetLayer() {
  const dispatch = useDispatch();
  const { slr3_4FeetLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, slr3_4FeetLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });

  if (slr3_4FeetLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: SLR3_4FEET_LAYER_ID,

      stroked: false,
      filled: true,
      getFillColor: [43, 133, 205],
      lineWidthMinPixels: 1,
      pickable: true,
      visible: slr3_4FeetLayer.visible,
      opacity: slr3_4FeetLayer.opacity,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: SLR3_4FEET_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['SLR_Zone_Area_Square_Meters'],
            }),
          };
        }
      },
    });
  }
}

export default SLR3_4FeetLayer;
